<template>
  <div>
    <span class="wizzard__summary-title">{{ title }}:</span>
    {{ value || EMPTY_VALUE_PLACEHOLDER }}
  </div>
</template>

<script setup lang="ts">
import { EMPTY_VALUE_PLACEHOLDER } from '@/const/common'

type Props = {
  title: string
  value?: string
}

defineProps<Props>()
</script>
